<div
  class="image-upload-container d-flex flex-column justify-content-center align-items-center"
>
  <div class="row w-100">
    <div class="modal-title col-7 ml-4 mb-1">
      {{ title }}
    </div>
    <div class="col-4 ml-4 p-0 d-flex justify-content-end">
      <img
        src="assets/svg/close.svg"
        alt="remove"
        class="remove-icon cursor-pointer"
        mat-dialog-close
      />
    </div>
  </div>
  <span class="modal-size">({{ data.width }}x{{ data.height }})</span>

  <div
    class="cropper-container d-flex flex-column justify-content-center align-items-center"
  >
    @if (!imageChangedEvent || data.imageUrl) {
      <div class="upload-input d-flex flex-column align-items-center">
        <label
          for="image-upload"
          class="file-upload px-3 cursor-pointer d-flex align-items-center justify-content-around"
        >
          <mat-icon color="primary">cloud_upload</mat-icon>
          Image Upload
        </label>
        <input
          id="image-upload"
          class="d-none"
          type="file"
          [accept]="imageExtensions"
          (change)="fileChangeEvent($event)"
        />
        @if (uploadFailed) {
          <span class="text-danger text-center d-flex align-items-center">
            Image upload failed, the image format should be .png, .jpg, .jpeg,
            .webp, or .bmp
          </span>
        }
      </div>
    }
    <image-cropper
      [imageChangedEvent]="imageChangedEvent"
      [imageURL]="data.imageUrl"
      [resizeToWidth]="data.width"
      [resizeToHeight]="data.height"
      [canvasRotation]="canvasRotation"
      [transform]="transform"
      [autoCrop]="true"
      output="base64"
      [backgroundColor]="'#141414'"
      (loadImageFailed)="loadImageFailed()"
    ></image-cropper>
  </div>
  <div class="d-flex flex-column align-items-center">
    <div
      class="control-buttons"
      [ngClass]="imageChangedEvent || data.imageUrl ? 'visible' : 'invisible'"
    >
      <button
        class="mr-1"
        mat-stroked-button
        color="primary"
        title="Rotate Left"
        (click)="rotateLeft()"
      >
        <mat-icon>rotate_left</mat-icon>
      </button>
      <button
        class="mr-1"
        mat-stroked-button
        color="primary"
        title="Rotate Right"
        (click)="rotateRight()"
      >
        <mat-icon>rotate_right</mat-icon>
      </button>
      <button
        class="mr-1"
        mat-stroked-button
        color="primary"
        title="Zoom In"
        (click)="zoomIn()"
      >
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button
        class="mr-1"
        mat-stroked-button
        color="primary"
        title="Zoom Out"
        (click)="zoomOut()"
      >
        <mat-icon>zoom_out</mat-icon>
      </button>
      <button
        class="mr-1"
        mat-stroked-button
        color="primary"
        title="Reset Image"
        (click)="resetImage()"
      >
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
    <div class="mt-2">
      <!--      <button class="ml-1"-->
      <!--              mat-stroked-button color="primary"-->
      <!--              title="Cancel"-->
      <!--              (click)="close()">-->
      <!--        Cancel-->
      <!--      </button>-->
      <button
        class="ml-1 button-primary game-btn"
        mat-stroked-button
        color="primary"
        title="Save"
        [disabled]="uploadFailed"
        (click)="processFile()"
      >
        Save
      </button>
    </div>
  </div>
</div>
